import React, { useRef } from "react";
import PrimeReact from "primereact/api";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-purple/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./index.css";
import { getUrlToAccountPage, getUrlToLoginPage, getUrlToLogoutPage, getUrlToPackagesPage, getUrlToPostPackagePage } from "pages/urls";
import { Button } from "primereact/button";
import { Menu } from 'primereact/menu';
import { AntidoteLogoBranding } from "components/AntidoteLogoBranding";
import { SHOP_HOST } from "config";
import { useNavigate } from "react-router-dom";
import { MenuItemCommandParams } from "primereact/menuitem";
import { useIsAuthenticated } from "shared/utils/auth";

type PropsT = {
  children: React.ReactNode;
};

export function DefaultLayout({ children }: PropsT) {
  return (
    <div className="min-h-screen">
      <NavBar />
      {children}
    </div>
  )
}

function NavBar () {
  const menu = useRef<any>(null);
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  
  const menuItems = [
    {label: 'Sell Items', icon: 'pi pi-fw pi-plus', url: getUrlToPostPackagePage()},
    {label: 'My Packages', icon: 'pi pi-fw pi-box', url: getUrlToPackagesPage()},
    {label: 'How It Works', icon: 'pi pi-fw pi-question-circle', url: 'https://blog.antidotenepal.com/2023/01/01/5625', external: true },
    {label: 'View Shop', icon: 'pi pi-fw pi-shopping-bag', url: SHOP_HOST, external: true },
    {label: 'Account', icon: 'pi pi-fw pi-user', url: getUrlToAccountPage()},
    {
      label: isAuthenticated ? 'Logout' : 'Login',
      icon: "pi pi-fw pi-arrow-circle-up",
      url: isAuthenticated
        ? getUrlToLogoutPage()
        : `${getUrlToLoginPage()}?from=${getUrlToPackagesPage()}`,
    },
  ].map(item => ({
    ...item,
    command: item.external
      ? undefined
      : (params: MenuItemCommandParams) => {
        navigate(item.url);
      },
    url: item.external ? item.url : undefined,
    target: item.external ? '_blank' :  undefined
  }));

  return (
    <div className="text-center py-2 border-bottom-1" style={{ borderColor: "#CCCCCC" }}>
      <div className="mb-2 mt-3 px-3 flex align-items-center justify-content-between">
        <AntidoteLogoBranding />
        <Menu model={menuItems} popup ref={menu}/>
        <Button className="p-button-text" icon="pi pi-bars" onClick={(event) => menu?.current?.toggle(event)}/>
      </div>
    </div>
  )
}

PrimeReact.ripple = true; // Enables animations for prime components
